import * as React from 'react';
import { type ReactElement } from 'react';

export const LoadingSpinner = (): ReactElement => (
    <div className="loader__overlay">
        <div className="loader__spinner"></div>
    </div>
);
